export const MAX_FEEDBACK_LENGTH = 5000;

export interface FeedbackRecord {
    id: string;
    text: string;
    organizationId: string;
    organizationName: string;
    userId: string;
    userName: string;
    userEmail: string;
    createdAt: string;
}
